/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import PropTypes from 'prop-types'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import InputLabel from '@material-ui/core/InputLabel'

// @material-ui/icons
import Event from '@material-ui/icons/Event'
import Modal from '../../../../components/feedback/modal'
import moment from 'moment'
import {
    Row,
    Col,
    Tooltip,
    Menu,
    Dropdown,
    Icon,
    Input,
    Progress,
    Avatar,
    Divider,
} from 'antd'
// core components
import GridContainer from '../../../../componentsMaterial/Grid/GridContainer.jsx'
import GridItem from '../../../../componentsMaterial/Grid/GridItem.jsx'
import CustomInput from '../../../../componentsMaterial/CustomInput/CustomInput.jsx'
import Clearfix from '../../../../componentsMaterial/Clearfix/Clearfix.jsx'
import Card from '../../../../componentsMaterial/Card/Card.jsx'
import CardBody from '../../../../componentsMaterial/Card/CardBody.jsx'
import CardHeader from '../../../../componentsMaterial/Card/CardHeader.jsx'
import CardIcon from '../../../../componentsMaterial/Card/CardIcon.jsx'
import ImageUpload from '../../../../componentsMaterial/CustomUpload/ImageUpload.jsx'

import Datetime from 'react-datetime'
import AddIcon from '@material-ui/icons/Add'
import ContentHolder from '../../../../components/utility/contentHolder'
import Fab from '@material-ui/core/Fab'
import Button from '../../../../components/uielements/button'
import Popover from '../../../../components/uielements/popover'
import { notification } from 'antd'

import userProfileStyles from './userProfileStyles'
// redux
import { IconSvg } from '../../../../componentIsoMophic/ScrumBoard/IconSvg/IconSvg'

import { connect } from 'react-redux'

import orgAction from '../../../../redux/organization/actions'
import Tags from '../../../../components/uielements/tag'
import TagWrapper from './tag.style'
import { Alert } from 'antd'
import scrumBoardActions from '../../../../redux/scrumBoard/actions'
import EventAction from '../../../../redux/event/actions'
import ObjectAction from '../../../../redux/object/actions'
import MediaAction from '../../../../redux/qbmedia/actions'

import MediaManagementScreen from '../../../MediaManagement/index'
import ObjectsScreen from '../../../ObjectsManagement/index'
import SelectMediaComponent from '../../../../components/select_medias'
import SelectObjectComponent from '../../../../components/select_objects'
import SelectEventComponent from '../../../../components/select_events'

import ReportActions from '../../../../redux/report/actions'
import objectDefault from '../../../../resource/image/objectDefault.png'

import defaultImgEvent from '../../../../resource/image/imgEventDefaul.jpg'

const { Search } = Input
const default_avatar = require('../../../../resource/image/defaultUser.png')

const Tag = props => (
    <TagWrapper>
        <Tags {...props}>{props.children}</Tags>
    </TagWrapper>
)
const seconds = new Date().getTime() / 1000
let temp = 1
class ContentCreateTask extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            time_end: seconds + 604800, // cong 1 tuan`
            content: '',
            name: '',
            visible: false,
            visibleDelete: false,
            TagAdd: '',
            currentTag: '',
            lstTag: [],
            nameState: '',
            contentstate: '',
            lastPageEventLoad: 1,
            isShowComfirm: false,
            isShowUpdate: false,
        }
        this.imgUpload = React.createRef()
    }

    componentDidMount() {
        this.props.loadListOrganization(0)
        this.props.getListEvent(1, 10, 0)
        this.props.searchUserByText('')
    }

    handleSimple = event => {
        this.setState({ organ_id: event.target.value })
    }
    getRandomInt = max => {
        return Math.floor(Math.random() * Math.floor(max))
    }
    getColorTag = () => {
        const color = [
            '#f50',
            '#2db7f5',
            '#87d068',
            '#108ee9',
            '#e6f542',
            '#f54242',
        ]
        const index = this.getRandomInt(color.length)

        return color[index]
    }

    componentWillUnmount() {
        console.log('unmount', this.state.isShowComfirm)
        this.props.resetDataEvent()
        this.props.resetDataObject()
        this.props.resetDataMedia()
        this.props.resetDataOrg()
        this.props.applyToMedia([])
        this.props.updateCurrentUserPickup([])
    }
    submitForm = lstTag => {
        const { updateEvent, currentEvent } = this.props
        const { time_end, content, name } = this.state
        if (name.trim() === '') {
            this.setState({ nameState: 'error' })
        } else if (content.trim() === '') {
            this.setState({ contentstate: 'error' })
        } else {
            this.setState({ nameState: 'success', contentstate: 'success' })
            let lstEvent = []
            this.props.ListCurrentEvent.map(event => {
                lstEvent.push(event.event_id)
            })
            let lstobject = []
            this.props.ListCurrentObject.map(obj => {
                lstobject.push(obj.object_id)
            })
            let lstmedia = []
            this.props.ListCurrentMedia.map(media => {
                lstmedia.push(media.media_id)
            })
            let lstOrg = []
            this.props.listOrgUpdate.map(org => {
                lstOrg.push(org.oid)
            })
            const listuidReceuive =[]
            this.props.currentUserPickUp.map(user => {
                listuidReceuive.push(user.uid)
            })
            const data = {
                deadline: parseInt(time_end, 10),
                note: content,
                name: name,
                avatar:
                    this.imgUpload.current.getUrlUpload() !== null
                        ? this.imgUpload.current.getUrlUpload()
                        : '',
                lst_hashtag: lstTag,
                lst_media: lstmedia,
                lst_object_id: lstobject,
                lst_event_id: lstEvent,
                lst_organ_receive_id: lstOrg,
                lst_uid_receive: listuidReceuive
            }
            console.log('data create event', data)
            this.props.createNewTask(data, this.props.history)
        }

        // if (timeStart === 0) {
        //     Object.assign(data, { begin_time: currentEvent.begin_time })
        // } else {
        //     Object.assign(data, { begin_time: timeStart })
        // }
        // if (time_end === 0) {
        //     Object.assign(data, { end_time: currentEvent.end_time })
        // } else {
        //     Object.assign(data, { end_time: time_end })
        // }
        // if (content === '') {

        // } else {
        //     Object.assign(data, { content: content })
        // }
        // if (name === '') {
        //     Object.assign(data, { name: currentEvent.name })
        // } else {
        //     Object.assign(data, { name: name })
        // }
        // if (this.imgUpload.current.getUrlUpload() === null) {
        //     Object.assign(data, { avatar: currentEvent.avatar })
        // } else {
        //     Object.assign(data, {
        //         avatar: this.imgUpload.current.getUrlUpload(),
        //     })
        // }
        // Object.assign(data, {
        //     hashtag: lstTag,
        // })
        console.log('')
    }
    clickLoadMoreEvent = () => {
        console.log('load more event', this.props.totalEvent)
        this.props.getListEvent(temp + 1, 10, 0)
        temp = temp + 1
    }
    _userSelectMedia = medias => {
        console.log('medias : ', medias)
        this.props.showModalMedia(false)
        this.props.applyToMedia([])
        this.props.applyToMedia(medias)
    }
    _userSelectObject = objects => {
        this.props.showModalObject(false)
        this.props.applyToCurrentObject([])
        this.props.applyToCurrentObject(objects)
    }
    _userSelectEvent = events => {
        this.props.visibleModalEvent(false)
        this.props.updateListCurrentEvent([])
        this.props.updateListCurrentEvent(events)
    }
    getListOrgCanAdd = () => {
        return this.props.organizations.filter(org => {
            const isInArray1 = this.props.listOrgUpdate.find(update => {
                return update.oid === org.oid
            })
            if (isInArray1) {
                return false
            } else {
                return true
            }
        })
    }
    getListEventCanAdd = () => {
        return this.props.events.filter(event => {
            const isInArray1 = this.props.ListCurrentEvent.find(update => {
                return update.event_id === event.event_id
            })
            if (isInArray1) {
                return false
            } else {
                return true
            }
        })
    }

    getListUserCanAdd = () => {
        if (this.props.listUserSearchByText) {
            return this.props.listUserSearchByText.filter(user => {
                const isInArray = this.props.currentUserPickUp.find(crr => {
                    return crr.uid === user.uid
                })

                if (isInArray) {
                    return false
                } else {
                    return true
                }
            })
        } else {
            return this.props.listUserSearchByText
        }
    }

    render() {
        const { classes } = this.props
        const { userInfo, currentEvent } = this.props
        const { lstTag, nameState } = this.state
        console.log('current ListCurrentEvent ', this.props.ListCurrentEvent)
        console.log('ListCurrentObject', this.props.ListCurrentObject)

        const contentAddUserJoin = (
            <div>
                <Search
                    placeholder="Nhập để tìm kiếm"
                    onChange={value =>
                        this.props.searchUserByText(value.target.value)
                    }
                    style={{ width: 200, marginLeft: 15 }}
                />
                <Divider style={{ margin: 7 }} />

                {this.getListUserCanAdd().length > 0 &&
                    this.getListUserCanAdd().map(user => (
                        <Button
                            style={{ display: 'flex', flexDirection: 'row', width: 250 }}
                            type="link"
                            onClick={() => {
                                this.props.updateCurrentUserPickup(user)
                            }}
                        >
                            <IconSvg
                                src={
                                    user.avatar === ''
                                        ? default_avatar
                                        : user.avatar
                                }
                                padding={'0'}
                                radius={'25% 25% 25% 25%'}
                            />
                            {user.display_name}
                        </Button>
                    ))}
                {this.props.listUserSearchByText.length === 0 && (
                    <div>Không có dữ liệu</div>
                )}
            </div>
        )

        return (
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" icon>
                                <CardIcon color="rose">
                                    <Event />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    Tạo nhiệm vụ
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <Card plain>
                                            <ImageUpload
                                                ref={this.imgUpload}
                                                addButtonProps={{
                                                    color: 'info',
                                                    round: true,
                                                    size: 'sm',
                                                }}
                                            />
                                            {/* </CardAvatar> */}
                                            <CardBody formHorizontal></CardBody>
                                        </Card>
                                    </GridItem>
                                    <GridContainer xs={12} sm={12} md={8}>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <CustomInput
                                                success={
                                                    nameState === 'success'
                                                }
                                                error={nameState === 'error'}
                                                labelText="Tên nhiệm vụ *"
                                                id="about-me"
                                                formControlProps={{
                                                    fullWidth: true,
                                                }}
                                                inputProps={{
                                                    onChange: e =>
                                                        this.setState({
                                                            name:
                                                                e.target.value,
                                                        }),
                                                    multiline: true,
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <br />
                                            <InputLabel
                                                className={classes.label}
                                            >
                                                Đơn vị tham gia
                                            </InputLabel>
                                            <ContentHolder>
                                                {this.props.listOrgUpdate.map(
                                                    value => (
                                                        <Popover
                                                            content={
                                                                <a
                                                                    onClick={() => {
                                                                        for (
                                                                            let i = 0;
                                                                            i <
                                                                            this
                                                                                .props
                                                                                .listOrgUpdate
                                                                                .length;
                                                                            i++
                                                                        ) {
                                                                            if (
                                                                                this
                                                                                    .props
                                                                                    .listOrgUpdate[
                                                                                    i
                                                                                ]
                                                                                    .oid ===
                                                                                value.oid
                                                                            ) {
                                                                                this.props.listOrgUpdate.splice(
                                                                                    i,
                                                                                    1
                                                                                )
                                                                            }
                                                                        }
                                                                        this.setState(
                                                                            {
                                                                                visibleDelete: false,
                                                                            }
                                                                        )
                                                                    }}
                                                                >
                                                                    Xoá đơn vị
                                                                    này
                                                                </a>
                                                            }
                                                            trigger="click"
                                                            onVisibleChange={e =>
                                                                this.setState({
                                                                    visibleDelete: e,
                                                                })
                                                            }
                                                        >
                                                            <Tooltip
                                                                title={
                                                                    value.name
                                                                }
                                                                placement="bottom"
                                                                key={Tooltip}
                                                            >
                                                                <IconSvg
                                                                    src={
                                                                        value
                                                                            .ext_data
                                                                            .avatarOrgani
                                                                    }
                                                                    padding={
                                                                        '0'
                                                                    }
                                                                    radius={
                                                                        '10% 30% 25%'
                                                                    }
                                                                    style={{
                                                                        marginTop: 5,
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </Popover>
                                                    )
                                                )}

                                                <Tooltip
                                                    title="Thêm đơn vị tham gia"
                                                    placement="bottom"
                                                >
                                                    <Dropdown
                                                        overlay={
                                                            <Menu>
                                                                {this.getListOrgCanAdd() &&
                                                                    this.getListOrgCanAdd().map(
                                                                        org => (
                                                                            <Menu.Item
                                                                                key={
                                                                                    org.oid
                                                                                }
                                                                                onClick={() =>
                                                                                    this.props.updateListOrgQuery(
                                                                                        org
                                                                                    )
                                                                                }
                                                                            >
                                                                                <IconSvg
                                                                                    src={
                                                                                        org
                                                                                            .ext_data
                                                                                            .avatarOrgani
                                                                                    }
                                                                                    padding={
                                                                                        '0'
                                                                                    }
                                                                                    radius={
                                                                                        '10% 30% 25%'
                                                                                    }
                                                                                />
                                                                                {
                                                                                    org.name
                                                                                }
                                                                            </Menu.Item>
                                                                        )
                                                                    )}
                                                            </Menu>
                                                        }
                                                        trigger={['click']}
                                                    >
                                                        <Fab
                                                            aria-label="add"
                                                            size="small"
                                                            color="secondary"
                                                            className={
                                                                classes.fab
                                                            }
                                                        >
                                                            <AddIcon />
                                                        </Fab>
                                                    </Dropdown>
                                                </Tooltip>
                                            </ContentHolder>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <br />
                                            <InputLabel
                                                className={classes.label}
                                            >
                                                Cá nhân tham gia
                                            </InputLabel>
                                            <ContentHolder>
                                                {this.props.currentUserPickUp.map(
                                                    user => (
                                                        <Tooltip
                                    title={user.display_name}
                                    placement="bottom"
                                    key={Tooltip}
                                >
                                    <Popover
                                            content={
                                                <a
                                                    onClick={() => {
                                                        for (
                                                            let i = 0;
                                                            i < this.props.currentUserPickUp.length;
                                                            i++
                                                        ) {
                                                            if (this.props.currentUserPickUp[i].uid === user.uid) {
                                                                let lst = this.props.currentUserPickUp
                                                                lst.splice(i,1)
                                                                console.log('list data', lst)                                                              
                                                                this.props.setCurrentUserPickUp(lst)
                                                                this.setState({isShowUpdate: true})
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Xoá cá nhân này
                                                </a>
                                            }
                                            trigger="click"
                                        >
                                            <IconSvg
                                                src={user.avatar === '' ? default_avatar : user.avatar}
                                                padding={'0'}
                                                radius={'10% 30% 25%'}
                                            />
                                        </Popover>
                                </Tooltip>
                                                    )
                                                )}

                                                <Tooltip
                                                    title="Thêm cá nhân tham gia"
                                                    placement="bottom"
                                                >
                                                    <Popover
                                                        placement="right"
                                                        content={
                                                            contentAddUserJoin
                                                        }
                                                        trigger="click"
                                                    >
                                                        <Fab
                                                            aria-label="add"
                                                            size="small"
                                                            color="secondary"
                                                            className={
                                                                classes.fab
                                                            }
                                                        >
                                                            <AddIcon />
                                                        </Fab>
                                                    </Popover>
                                                </Tooltip>
                                            </ContentHolder>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <br />
                                            <InputLabel
                                                className={classes.label}
                                            >
                                                HashTag
                                            </InputLabel>
                                            <ContentHolder>
                                                {lstTag.map(value => (
                                                    <Popover
                                                        content={
                                                            <a
                                                                onClick={() => {
                                                                    for (
                                                                        let i = 0;
                                                                        i <
                                                                        lstTag.length;
                                                                        i++
                                                                    ) {
                                                                        if (
                                                                            lstTag[
                                                                                i
                                                                            ] ===
                                                                            value
                                                                        ) {
                                                                            lstTag.splice(
                                                                                i,
                                                                                1
                                                                            )
                                                                        }
                                                                    }
                                                                    this.setState(
                                                                        {
                                                                            visibleDelete: false,
                                                                        }
                                                                    )
                                                                }}
                                                            >
                                                                Xoá hashtag này
                                                            </a>
                                                        }
                                                        trigger="click"
                                                        // visible={
                                                        //     value ===
                                                        //     this.state
                                                        //         .currentTag
                                                        // }
                                                        onVisibleChange={e =>
                                                            this.setState({
                                                                visibleDelete: e,
                                                            })
                                                        }
                                                    >
                                                        <Tag
                                                            color={this.getColorTag()}
                                                            onClick={() => {
                                                                this.setState({
                                                                    currentTag: value,
                                                                })
                                                            }}
                                                        >
                                                            {value}
                                                        </Tag>
                                                    </Popover>
                                                ))}

                                                <Fab
                                                    aria-label="add"
                                                    size="small"
                                                    color="secondary"
                                                    className={classes.fab}
                                                    onClick={() =>
                                                        this.setState({
                                                            visible: true,
                                                        })
                                                    }
                                                >
                                                    <AddIcon />
                                                </Fab>
                                            </ContentHolder>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                            <InputLabel
                                                style={{ paddingTop: 15 }}
                                                className={classes.label}
                                            >
                                                Thời gian kết thúc
                                            </InputLabel>

                                            <Datetime
                                                timeFormat={false}
                                                strictParsing
                                                isValidDate={(
                                                    currentDate,
                                                    selectedDate
                                                ) => {
                                                    if (
                                                        currentDate > moment()
                                                    ) {
                                                        return true
                                                    }
                                                }}
                                                value={moment(
                                                    this.state.time_end * 1000
                                                ).format('DD/MM/YYYY')}
                                                closeOnSelect
                                                onChange={e =>
                                                    this.setState({
                                                        time_end:
                                                            e._d.valueOf() /
                                                            1000,
                                                    })
                                                }
                                                inputProps={{
                                                    placeholder:
                                                        'Thời gian kết thúc',
                                                    readOnly: true,
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridContainer>

                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <InputLabel
                                            style={{ paddingTop: 15 }}
                                            className={classes.label}
                                        >
                                            Tài liệu liên quan
                                        </InputLabel>
                                        {this.props.ListCurrentMedia.map(
                                            media => (
                                                <a
                                                    type="link"
                                                    // href={media.url}
                                                    target="_blank"
                                                    onClick={() => {
                                                        window.open(
                                                            media.url,
                                                            '_blank'
                                                        )
                                                    }}
                                                    block={false}
                                                    style={{
                                                        paddingLeft: 5,
                                                        color: '#1a73e8',
                                                        textDecorationLine:
                                                            'underline',
                                                        paddingRight: 10,
                                                    }}
                                                >
                                                    {media.name}
                                                </a>
                                            )
                                        )}
                                        <Button
                                            type="primary"
                                            icon="upload"
                                            onClick={() =>
                                                this.props.showModalMedia(true)
                                            }
                                            style={{
                                                width: 170,
                                                marginTop: 10,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            Chọn tài liệu
                                        </Button>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <InputLabel
                                            style={{ paddingTop: 15 }}
                                            className={classes.label}
                                        >
                                            Đối tượng liên quan
                                        </InputLabel>
                                        {this.props.ListCurrentObject.map(
                                            object => (
                                                <Tooltip
                                                    title={object.name}
                                                    placement="bottom"
                                                    key={object}
                                                >
                                                    <Avatar
                                                        shape="square"
                                                        size={64}
                                                        src={
                                                            object.avatar === ''
                                                                ? objectDefault
                                                                : object.avatar
                                                        }
                                                        style={{ margin: 10 }}
                                                    />
                                                </Tooltip>
                                            )
                                        )}
                                        <Button
                                            type="primary"
                                            icon="upload"
                                            onClick={() =>
                                                this.props.showModalObject(true)
                                            }
                                            style={{
                                                marginTop: 10,
                                                width: 170,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            Chọn đối tượng
                                        </Button>
                                    </GridItem>
                                </GridContainer>

                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <InputLabel
                                            style={{ paddingTop: 15 }}
                                            className={classes.label}
                                        >
                                            Sự kiện liên quan
                                        </InputLabel>
                                        {this.props.ListCurrentEvent.map(
                                            event => (
                                                <Tooltip
                                                    title={event.name}
                                                    placement="bottom"
                                                    key={event}
                                                >
                                                    <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href={`/app/qbevents/${event.event_id}`}
                                                    >
                                                        <Avatar
                                                            shape="square"
                                                            size={64}
                                                            src={
                                                                event.avatar ===
                                                                ''
                                                                    ? defaultImgEvent
                                                                    : event.avatar
                                                            }
                                                            style={{
                                                                margin: 10,
                                                            }}
                                                        />
                                                    </a>
                                                </Tooltip>
                                            )
                                        )}
                                        <Button
                                            type="primary"
                                            icon="upload"
                                            onClick={() =>
                                                this.props.visibleModalEvent(
                                                    true
                                                )
                                            }
                                            style={{
                                                marginTop: 10,
                                                width: 170,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            Chọn sự kiện
                                        </Button>
                                    </GridItem>
                                </GridContainer>

                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Card profile>
                                            <br />
                                            <InputLabel
                                                style={{
                                                    color:
                                                        this.state
                                                            .contentstate ===
                                                        'error'
                                                            ? 'red'
                                                            : 'black',
                                                    fontSize: 18,
                                                }}
                                            >
                                                Nội dung *
                                            </InputLabel>
                                            <CustomInput
                                                success={
                                                    this.state.contentstate ===
                                                    'success'
                                                }
                                                error={
                                                    this.state.contentstate ===
                                                    'error'
                                                }
                                                labelText="Nội dung nhiệm vụ"
                                                id="about-me"
                                                formControlProps={{
                                                    fullWidth: true,
                                                }}
                                                inputProps={{
                                                    placeholder:
                                                        'Nội dung nhiệm vụ',
                                                    onChange: e =>
                                                        this.setState({
                                                            content:
                                                                e.target.value,
                                                        }),

                                                    multiline: true,
                                                    rows: 10,
                                                }}
                                            />
                                        </Card>
                                    </GridItem>
                                </GridContainer>
                                <Button
                                    type="primary"
                                    className={classes.updateProfileButton}
                                    onClick={() => this.submitForm(lstTag)}
                                >
                                    Tạo nhiệm vụ
                                </Button>
                                <Button
                                    type="danger"
                                    className={classes.updateProfileButton}
                                    onClick={() => {
                                        this.props.visibleModalCreateTaskAction(
                                            false
                                        )
                                    }}
                                    style={{ marginRight: 20 }}
                                >
                                    Huỷ
                                </Button>
                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>

                {this.props.VisibleModalMedia && (
                    <Modal
                        visible={true}
                        title="Lựa chọn tài liệu"
                        onOk={() => this.props.showModalMedia(false)}
                        onCancel={() => this.props.showModalMedia(false)}
                        centered
                        width={900}
                        footer={null}
                    >
                        <SelectMediaComponent
                            onSuccess={medias => this._userSelectMedia(medias)}
                            onCancel={() => this.props.showModalMedia(false)}
                            initMedia={this.props.ListCurrentMedia}
                        />
                    </Modal>
                )}
                {this.props.VisibleModalObject && (
                    <Modal
                        visible={true}
                        title="Lựa chọn đối tượng"
                        onOk={() => this.props.showModalObject(false)}
                        onCancel={() => this.props.showModalObject(false)}
                        width={900}
                        centered
                        footer={[]}
                    >
                        <SelectObjectComponent
                            onSuccess={objects =>
                                this._userSelectObject(objects)
                            }
                            onCancel={() => this.props.showModalObject(false)}
                            initObject={this.props.ListCurrentObject}
                        />
                    </Modal>
                )}
                {this.props.VisibleModalEvent && (
                    <Modal
                        visible={true}
                        title="Sự kiện liên quan"
                        onOk={() => this.props.visibleModalEvent(false)}
                        onCancel={() => this.props.visibleModalEvent(false)}
                        width={900}
                        centered
                        footer={[]}
                    >
                        <SelectEventComponent
                            onSuccess={events => this._userSelectEvent(events)}
                            onCancel={() => this.props.visibleModalEvent(false)}
                            initEvent={this.props.ListCurrentEvent}
                        />
                    </Modal>
                )}

                {this.state.visible && (
                    <Modal
                        visible={true}
                        title="Thêm hash tag"
                        onOk={() => this._handleOK()}
                        onCancel={() => this.setState({ visible: false })}
                        centered
                        footer={[
                            <Button
                                key="submit"
                                size="large"
                                type="danger"
                                onClick={() => {
                                    let temp = true
                                    lstTag.find(e => {
                                        if (e === this.state.TagAdd.trim()) {
                                            temp = false
                                        }
                                    })
                                    if (!temp) {
                                        notification.error({
                                            message: 'Hash tag này đã có',
                                        })
                                    } else {
                                        if (this.state.TagAdd.trim() !== '') {
                                            lstTag.push(
                                                this.state.TagAdd.trim()
                                            )
                                            this.setState({
                                                visible: false,
                                                TagAdd: '',
                                            })
                                        }
                                    }
                                }}
                            >
                                Thêm
                            </Button>,
                        ]}
                    >
                        <CustomInput
                            formControlProps={{
                                fullWidth: true,
                            }}
                            onKeyDown={key => {
                                if (key.key === 'Enter') {
                                    console.log('enter')
                                    let temp = true
                                    lstTag.find(e => {
                                        if (e === this.state.TagAdd.trim()) {
                                            temp = false
                                        }
                                    })
                                    if (!temp) {
                                        notification.error({
                                            message: 'Hash tag này đã có',
                                        })
                                    } else {
                                        if (this.state.TagAdd.trim() !== '') {
                                            lstTag.push(
                                                this.state.TagAdd.trim()
                                            )
                                            this.setState({
                                                visible: false,
                                                TagAdd: '',
                                            })
                                        }
                                    }
                                }
                            }}
                            isAutoFocus={true}
                            error={this.state.TagAdd.trim() === ''}
                            inputProps={{
                                onChange: event => {
                                    if (event.target.value.length < 30) {
                                        this.setState({
                                            TagAdd: event.target.value,
                                        })
                                    }
                                },
                                multiline: true,
                                value: this.state.TagAdd,
                            }}
                        />
                        {this.state.TagAdd.trim() === '' && (
                            <text style={{ color: 'red' }}>
                                Không được để trống{' '}
                            </text>
                        )}
                    </Modal>
                )}
            </div>
        )
    }
}

ContentCreateTask.propTypes = {
    classes: PropTypes.object,
}
const mapStateToProps = state => {
    return {
        organizations: state.organization.organizations,
        listOrgUpdate: state.organization.listOrgUpdate,
        VisibleModalMedia: state.scrumBoard.VisibleModalMedia,
        VisibleModalObject: state.scrumBoard.VisibleModalObject,
        ListCurrentMedia: state.scrumBoard.ListCurrentMedia,
        ListCurrentObject: state.scrumBoard.ListCurrentObject,
        ListCurrentEvent: state.scrumBoard.ListCurrentEvent,
        VisibleModalEvent: state.scrumBoard.VisibleModalEvent,
        events: state.eventReducer.events,
        listUserSearchByText: state.scrumBoard.listUserSearchByText,
        totalEvent: state.eventReducer.totalEvent,
        currentUserPickUp: state.scrumBoard.currentUserPickUp,
        lstCurrentUser: state.scrumBoard.lstCurrentUser,


        // selected_Media: state.qbreport.selected_Media,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListOrganization: loadtype => {
            dispatch(orgAction.action.loadListOrganization(loadtype))
        },
        updateListOrgQuery: org => {
            dispatch(orgAction.action.updateListOrgQuery(org))
        },
        showModalMedia: visible => {
            dispatch(scrumBoardActions.showModalMedia(visible))
        },
        showModalObject: visible => {
            dispatch(scrumBoardActions.showModalObject(visible))
        },
        updateListCurrentEvent: data => {
            dispatch(scrumBoardActions.updateListCurrentEvent(data))
        },
        getListEvent: (page_number, page_size, deleted) => {
            dispatch(
                EventAction.action.getListEvent(page_number, page_size, deleted)
            )
        },
        createNewTask: (body, history) => {
            dispatch(scrumBoardActions.createNewTask(body, history))
        },
        resetDataEvent: () => {
            dispatch(scrumBoardActions.getListCurrentEventDone([]))
        },
        resetDataObject: () => {
            dispatch(ObjectAction.action.getListObjectQueryById_done([]))
        },
        resetDataMedia: () => {
            dispatch(MediaAction.action.getListMediaQueryByIdDone([]))
        },
        resetDataOrg: () => {
            dispatch(orgAction.action.deleteListOrgQuery())
        },
        visibleModalCreateTaskAction: visible => {
            dispatch(scrumBoardActions.visibleModalCreateTaskAction(visible))
        },
        applyToMedia: data => {
            dispatch(scrumBoardActions.applyToMedia(data))
        },
        applyToCurrentObject: data => {
            dispatch(scrumBoardActions.applyToCurrentObject(data))
        },
        visibleModalEvent: visible => {
            dispatch(scrumBoardActions.visibleModalEvent(visible))
        },
        searchUserByText: value => {
            dispatch(scrumBoardActions.searchUserByText(value))
        },
        updateCurrentUserPickup: user => {
            dispatch(scrumBoardActions.updateCurrentUserPickup(user))
        },
        setCurrentUserPickUp: data =>{
            dispatch(scrumBoardActions.setCurrentUserPickUp(data))
        }
        
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(userProfileStyles)(ContentCreateTask))
